import { useRef } from 'react'

const useDragOver = (id, isOpen, dragOverHandler) => {
  const stack = useRef(0)
  const timer = useRef(0)

  const onDragEnter = () => {
    stack.current += 1

    if (stack.current === 1 && !isOpen) {
      timer.current = window.setTimeout(() => dragOverHandler(id), 500)
    }
  }

  const onDragLeave = () => {
    stack.current -= 1

    if (stack.current === 0) {
      window.clearTimeout(timer.current)
    }
  }

  const onDrop = () => {
    if (timer.current > 0) {
      window.clearTimeout(timer.current)
    }

    stack.current = 0
    timer.current = 0
  }

  return {
    onDragEnter,
    onDragLeave,
    onDrop,
  }
}

export default useDragOver
